import { Box, Grid, Tooltip, Typography } from '@mui/material'
import _ from 'lodash'
import { memo, useCallback, useMemo } from 'react'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** COMPONENT */

/** CONSTANTS */
import { colors } from 'constants/theme'

/** HOOKS */

/** UTILS */

/** API */

/** STYLE */
import { fileUrl } from 'api/api'
import Advance from 'assets/icon/payment-method/advanced'
import Bank from 'assets/icon/payment-method/bank'
import Cash from 'assets/icon/payment-method/cash'
import Credit from 'assets/icon/payment-method/credit'
import Debit from 'assets/icon/payment-method/debit'
import TreatmentRight from 'assets/icon/payment-method/treatmentRight'
import { onImgError } from 'constants/images'
import * as UseStyled from 'features/finance/payment/component/popupPaymentTemp/UseStyledFormPayment'


import Wallet from 'assets/icon/payment-method/wallet'
import { notiError } from 'component/notifications/notifications'
import { Config } from 'config'
import { numberToCurrencyFormat } from 'utils/app.utils'
import { PaidItem } from './Index'
import Privilege from './Privilege'
import PrivilegeList from './PrivilegeList'
import TreatmentDiscount from './TreatmentDiscount'
import { PaymentChannelsType } from './types/types'
import { getItemType } from './utils/paymentUtils'





function PaymentChannels(props: PaymentChannelsType) {
  const { t } = useTranslation()


  // Use provided banks or fallback to hook banks
  const bankTransfers = props.bankTransfers || []
  const bankCredits = props.bankCredits || []
  const bankDebits = props.bankDebits || []

  // Filter payment channels based on conditions
  const visiblePaymentChannels = useMemo(() => {
    const newObject: any = {}
    Object.values(props.selectdChannel).sort((a: any, b: any) => (a.sorting ?? 9999) - (b.sorting ?? 9999)).forEach((channel: any) => {
      // Skip VOUCHER and PROMOTION (handled separately)
      channel.isDisabled = false
      if (channel?.paymentChanel === 8 || channel?.paymentChanel === 7) return

      // TDH config filtering
      if (Config.IS_TDH === '1' && channel?.key === 'DEBIT') return

      if (Config.IS_TDH === '0' && channel?.key === 'WALLET') return

      // Advance mode filtering
      if (props.advance && (channel.key === 'TREATMENTRIGHT' || channel.key === 'ADVANCE')) return
      // if (props.systemConfig.menu === 'EDIT_PAYMENT' && channel.key === 'TREATMENTRIGHT') channel.isDisabled = true

      newObject[channel.key] = { ...channel }
    });
    return newObject
  }, [props.selectdChannel])

  const isMenu = useMemo(() => (props.systemConfig.menu), [props.systemConfig.menu])

  // Helper function to get DCC amount from listOrder
  const getDccFromListOrder = (itemId: any, itemType: string) => {
    let paidDcc = 0
    let foundItem: any = null
    const item = _.find(props.listOrder, (treatment: any, index: number) => {
      const { type, id } = getItemType(treatment, isMenu, index)

      return Number(id) === Number(itemId) && type === itemType
    })
    for (const his of props?.histories || []) {
      foundItem = _.find(his.itemBalances, (item: any) =>
        Number(item.refItemId) === Number(itemId) && item.refItemType === itemType
      )

      console.log('foundItem', foundItem?.paidDcc, his.itemBalances, props?.histories)
      paidDcc += (foundItem?.paidDcc || 0)
    }

    console.log('paidDcc', paidDcc, itemId, itemType, item, foundItem?.paidDcc)
    return (parseFloat(item?.totalDcc) || 0) - paidDcc
  }


  const handleSelectPaymentChannel = useCallback((channel: any) => {
    const paymentChannelId = channel.paymentChanel
    const newIsActive = !channel.isActive


    const selectdChannel = props.selectdChannel
    // Cache values to avoid repeated access
    const listOrderPayment = props.listOrderPayment
    const paidChannel = listOrderPayment?.paidChannel?.[paymentChannelId]
    const paidItem = listOrderPayment?.paid || {}
    const itemChannel = paidChannel?.itemChannel || {}

    let treatmentRight = listOrderPayment?.treatmentRight || null
    const promotion = listOrderPayment?.promotion || null
    let promotions = listOrderPayment?.promotions ?? {}
    let vouchers = listOrderPayment?.vouchers ?? {}
    if (channel.key === 'TREATMENTRIGHT' && !newIsActive) treatmentRight = null
    if (channel.key === 'PROMOTION' && !newIsActive) promotions = {}
    if (channel.key === 'VOUCHER' && !newIsActive) vouchers = {}

    // Update channel state
    const updatedChannel = { ...channel, isActive: newIsActive, bank: null }
    const checkLengthActive = Object.values(selectdChannel).filter((item: any) => item.isActive).length

    // Calculate active channels count efficiently
    let activeCount = 0
    if (newIsActive) {
      // Count existing active channels
      Object.values(selectdChannel).forEach((item: any) => {
        if (item.isActive) activeCount++
      })
      updatedChannel.channelIndex = activeCount + 1
    } else {
      updatedChannel.channelIndex = null
    }

    // Create updated selectdChannel
    const updatedSelectdChannel = { ...selectdChannel, [paymentChannelId]: updatedChannel }

    // Sort and update channel indices in one pass
    const sortedChannels = Object.values(updatedSelectdChannel)
      .sort((a: any, b: any) => (a.channelIndex ?? 9999) - (b.channelIndex ?? 9999))


    let channelIndex = 1
    let activeChannelCount = 0
    const finalSelectdChannel = { ...updatedSelectdChannel }

    sortedChannels.forEach((item: any) => {
      if (item.isActive) {
        finalSelectdChannel[item.paymentChanel] = { ...item, channelIndex: channelIndex++ }
        activeChannelCount++
      } else {
        finalSelectdChannel[item.paymentChanel] = { ...item, channelIndex: null }
      }
    })

    // Prepare updated paid and paidChannel objects
    const updatedPaidItem = { ...paidItem }
    const updatedItemChannel: Record<string, any> = {}
    let amountPaid = 0

    const keyDefault = ['CASH', 'ADVANCE', 'WALLET', 'TRANSFER', 'CREDIT', 'DEBIT']
    if (activeChannelCount === 1 && keyDefault.includes(channel.key) && checkLengthActive === 0) {
      // Single active channel: auto-select all items

      let remainingAmount = 0;
      if (paymentChannelId === 6) {
        remainingAmount = props.advanceBalance;
      }

      Object.keys(itemChannel).forEach((key, index) => {
        const item = paidItem[key]
        let treatmentPrice = item?.treatmentPrice || 0

        if (props.systemConfig.menu === 'OVERDUE' || props.systemConfig.menu === 'EDIT_PAYMENT') {
          treatmentPrice = treatmentPrice - Number(paidItem[key]?.paid || 0)
        }

        let amountPaidItem = treatmentPrice;
        if (paymentChannelId === 6) {
          if (remainingAmount === 0) amountPaidItem = 0;
          else if (remainingAmount > 0 && remainingAmount < treatmentPrice) {
            amountPaidItem = remainingAmount
            remainingAmount = 0;
          } else if (remainingAmount > treatmentPrice) {
            amountPaidItem = treatmentPrice
            remainingAmount -= amountPaidItem;
          }
        }

        let balance = treatmentPrice - amountPaidItem;
        if (balance < 0) balance = 0;


        updatedItemChannel[key] = {
          checked: true,
          disabledChecked: false,
          disabledInput: false,
          value: amountPaidItem,
          dccAmount: getDccFromListOrder(item?.id, item?.type)
        }
        amountPaid += amountPaidItem
        updatedPaidItem[key] = { ...paidItem[key], value: amountPaidItem, balance: balance, treatmentPrice: paidItem[key]?.treatmentPrice }
      })
      const updatedPaidChannel = {
        ...paidChannel,
        checked: true,
        disabledChecked: false,
        disabledInput: false,
        amountPaid,
        itemChannel: updatedItemChannel
      }

      const next = {
        ...listOrderPayment,
        paid: updatedPaidItem,
        paidChannel: { ...listOrderPayment?.paidChannel, [paymentChannelId]: updatedPaidChannel },
        treatmentRight: treatmentRight,
        promotion: promotion
      }

      props.setListOrderPayment(updateSummary(next));
    } else {

      // Multiple or no active channels: reset values
      Object.keys(itemChannel).forEach((key) => {
        const oldValue = paidChannel.itemChannel[key]?.value || 0
        let treatmentPrice = paidItem[key]?.treatmentPrice || 0
        if (props.systemConfig.menu === 'OVERDUE' || props.systemConfig.menu === 'EDIT_PAYMENT') {
          treatmentPrice = Number(treatmentPrice) - Number(paidItem[key]?.paid || 0)
        }

        updatedItemChannel[key] = {
          checked: false,
          disabledChecked: false,
          disabledInput: true,
          value: 0,
          dccAmount: 0
        }

        updatedPaidItem[key] = {
          ...paidItem[key],
          value: (paidItem[key]?.value || 0) - oldValue,
          balance: (paidItem[key]?.balance || 0) + oldValue,
          treatmentPrice: paidItem[key]?.treatmentPrice || 0
        }
      })
      const amountPaid = _.sumBy(Object.values(itemChannel), (it: any) => Number(it?.value) || 0);


      const updatedPaidChannel = {
        ...paidChannel,
        checked: newIsActive ? true : false,
        disabledChecked: false,
        disabledInput: false,
        amountPaid: amountPaid,
        itemChannel: updatedItemChannel
      }
      const next = {
        ...listOrderPayment,
        paid: updatedPaidItem,
        paidChannel: { ...listOrderPayment?.paidChannel, [paymentChannelId]: updatedPaidChannel },
        treatmentRight: treatmentRight,
        promotion: paymentChannelId === 8 && !newIsActive ? null : listOrderPayment?.promotion,
        promotions: paymentChannelId === 8 ? promotions : (listOrderPayment?.promotions ?? {}),
        vouchers: paymentChannelId === 7 ? vouchers : (listOrderPayment?.vouchers ?? {}),
        voucher: paymentChannelId === 7 && !newIsActive ? null : listOrderPayment?.voucher
      }

      props.setListOrderPayment(updateSummary(next));
    }

    if (Number(paymentChannelId) === 1) {
      props.setObjPayment((prev: any) => ({ ...prev, amountChange: 0 }))
    }

    props.setSelectdChannel({ ...finalSelectdChannel })
  }, [props.selectdChannel, props.setSelectdChannel, props.listOrderPayment, props.setListOrderPayment, props.objPayment.approvedArrear])


  // ✅ Refactored: รวม logic การเลือกธนาคาร
  const handleSelectBank = useCallback((channel: any, newBank: any) => {
    let prev = props.selectdChannel

    const key = channel.paymentChanel;
    const current = prev?.[key] ?? channel;
    const nextBank = current?.bank?.bankId !== newBank.bankId ? newBank : null;
    prev = { ...prev, [key]: { ...current, bank: nextBank }, };


    props.setSelectdChannel({ ...prev });
  }, [props.setSelectdChannel, props.selectdChannel]);

  const handleSelectCardType = useCallback((channel: any, cardType: any) => {
    let prev = props.selectdChannel
    const key = channel.paymentChanel;
    const current = prev?.[key] ?? channel;
    prev = { ...prev, [key]: { ...current, bank: { ...current?.bank, ...cardType } }, };

    props.setSelectdChannel({ ...prev });
  }, [props.setSelectdChannel, props.selectdChannel]);

  const handleSelectPaymentChannelTransfer = useCallback((channel, bank: any) => {
    return handleSelectBank(channel, bank)
  }, [handleSelectBank])

  const handleSelectPaymentChannelCredit = useCallback((channel, bank: any) => {
    return handleSelectBank(channel, bank)
  }, [handleSelectBank])

  const handleSelectPaymentChannelDebit = useCallback((channel, bank: any) => {
    return handleSelectBank(channel, bank)
  }, [handleSelectBank])

  const handleSelectPaymentChannelCard = useCallback((channel, cardType: any) => {
    return handleSelectCardType(channel, cardType)
  }, [handleSelectCardType])


  const handleCheckBox = useCallback((paymentChannelId: number, type: string, id: any) => {
    const itemKey = `${type}_${id}`;
    const prev = props.listOrderPayment;
    if (!prev) return prev;

    const paidItem: Record<string, PaidItem> = prev.paid ?? {};
    const currentPaidItem: PaidItem = paidItem[itemKey];
    if (!currentPaidItem) return prev;

    const paidChannel = prev.paidChannel?.[paymentChannelId];
    if (!paidChannel) return prev;

    const itemChannel = paidChannel.itemChannel ?? {};
    const currentItemChannel =
      itemChannel[itemKey] ?? { checked: false, disabledChecked: false, disabledInput: true, value: 0 };

    const newChecked = !currentItemChannel.checked;
    const newDisabledInput = !newChecked;

    // ถ้า uncheck ให้คืนยอดช่องนี้เป็น 0
    const oldChannelValue = Number(currentItemChannel.value) || 0;
    const newValue = newChecked ? oldChannelValue : 0;

    // totalPaid ใหม่ = totalPaid เดิม - oldChannelValue + newValue
    const currentTotalPaid = Number(currentPaidItem.value) || 0;
    const newTotalPaid = Math.max(0, currentTotalPaid - oldChannelValue + newValue);

    let treatmentPrice = Number(currentPaidItem.treatmentPrice) || 0;
    if (props.systemConfig.menu === 'OVERDUE' || props.systemConfig.menu === 'EDIT_PAYMENT') {
      treatmentPrice = treatmentPrice - Number(currentPaidItem?.paid || 0)
    }

    const newBalance = Math.max(0, treatmentPrice - newTotalPaid);

    const updatedItemChannel = {
      ...itemChannel,
      [itemKey]: {
        ...currentItemChannel,
        checked: newChecked,
        disabledInput: newDisabledInput,
        value: newValue,
      },
    };

    const updatedPaid = {
      ...paidItem,
      [itemKey]: {
        ...currentPaidItem,
        value: newTotalPaid,
        balance: newBalance,
      },
    };

    // อัปเดต amountPaid ของช่องทางให้ตรง
    const amountPaid = _.sumBy(Object.values(updatedItemChannel), (it: any) => Number(it?.value) || 0);

    const updatedPaidChannel = {
      ...paidChannel,
      itemChannel: updatedItemChannel,
      amountPaid,
    };

    const next = {
      ...prev,
      paid: updatedPaid,
      paidChannel: { ...prev.paidChannel, [paymentChannelId]: updatedPaidChannel, },
    }

    props.setListOrderPayment(updateSummary(next));
  }, [props.listOrderPayment, props.setListOrderPayment]);

  const checkCheckedTreatmentRight = useCallback((treatmentRight: any, patientTreatmentRightId: number) => {
    Object.keys(treatmentRight).forEach((key: any) => {
      const item = treatmentRight[key]
      if (Number(key) !== patientTreatmentRightId && item.checked) return true;
    })
    return false;
  }, []);

  const calcDfCfForBenefit = useCallback((value: number, benefitData: any) => {
    const usage = benefitData?.benefitUsage || benefitData?.voucherUsage || benefitData?.promotionUsage || 'ALL'

    console.log('benefitData', benefitData)
    if (usage === 'OPERATIVEDF') return { dfAmount: value, cfAmount: 0 }
    if (usage === 'OPERATIVECF') return { dfAmount: 0, cfAmount: value }
    if (usage === 'OPERATIVE') {
      const df = Number(benefitData?.benefitPriceDF ?? benefitData?.voucherPriceDF ?? benefitData?.promotionPriceDF) || 0
      const cf = Number(benefitData?.benefitPriceCF ?? benefitData?.voucherPriceCF ?? benefitData?.promotionPriceCF) || 0
      const unit = benefitData?.benefitPriceDFUnit || benefitData?.voucherPriceDFUnit || benefitData?.promotionPriceDFUnit || 'BAHT'
      if (unit === 'PERCENT') {
        return { dfAmount: Math.round(value * (df / 100) * 100) / 100, cfAmount: Math.round(value * (cf / 100) * 100) / 100 }
      }
      const total = df + cf
      if (total > 0) {
        const r = df / total
        return { dfAmount: Math.round(value * r * 100) / 100, cfAmount: Math.round(value * (1 - r) * 100) / 100 }
      }
    }
    return { dfAmount: 0, cfAmount: 0 }
  }, [])

  const handleSelectBenefit = useCallback((treatmentRight: any) => {
    const { patientTreatmentRightId, treatmentRightId, } = treatmentRight;
    const { promotionBranchId, voucherListId } = treatmentRight;

    console.log('treatmentRight', treatmentRight)


    const paidItem: Record<string, PaidItem> = props.listOrderPayment?.paid || {}
    let next = { ...props.listOrderPayment };
    // เงื่อนไข: เป็น Voucher และยังไม่หมดอายุ
    if (promotionBranchId || voucherListId) {
      const prevPromotions = props.listOrderPayment?.promotions ?? {};
      const prevVouchers = props.listOrderPayment?.vouchers ?? {};

      let benefitBranchId = promotionBranchId || voucherListId;
      if (voucherListId && prevVouchers[voucherListId]) {
        const nextVouchers = { ...prevVouchers };
        delete nextVouchers[voucherListId];
        next = { ...props.listOrderPayment, vouchers: nextVouchers, voucher: {} };
      } else if (promotionBranchId && prevPromotions[promotionBranchId]) {
        const nextPromotions = { ...prevPromotions };
        delete nextPromotions[promotionBranchId];
        next = { ...props.listOrderPayment, promotions: nextPromotions, promotion: {} };
      } else {
        benefitBranchId = treatmentRight?.voucherListId || treatmentRight?.promotionBranchId;

        let checkCanUseTr: any[] = []
        const benefitType = treatmentRight?.voucherListId ? 'voucher' : 'promotion';

        const benefitPriceUnit = treatmentRight?.voucherPriceUnit || treatmentRight?.promotionPriceUnit
        const benefitPrice = treatmentRight?.voucherPrice || treatmentRight?.promotionPrice
        const benefitPriceType = treatmentRight?.voucherPriceType || treatmentRight?.promotionPriceType
        const benefitItems = treatmentRight?.items
        const benefitUsage = treatmentRight?.voucherUsage || treatmentRight?.promotionUsage || 'ALL'
        const benefitPriceDF = Number(treatmentRight?.voucherPriceDF ?? treatmentRight?.promotionPriceDF) || 0
        const benefitPriceCF = Number(treatmentRight?.voucherPriceCF ?? treatmentRight?.promotionPriceCF) || 0
        const benefitPriceDFUnit = treatmentRight?.voucherPriceDFUnit || treatmentRight?.promotionPriceDFUnit || 'BAHT'

        const benefitPriceUse: any = {}

        /** 
         * !! กรณีที่ผูกกับรายการ
         * ต้องเช็ค ว่ามีรายการที่เข้าเงื่อนไขมั้ย 
         * voucherPriceType DISCOUNT || SALEPRICE (มูลค่าลด || ราคาหลังลด)
         */
        if (benefitItems && benefitItems.length) {
          checkCanUseTr = _.map(benefitItems, (item) => {
            const usableVoucher = Object.keys(paidItem).find((tr: any) => {
              const itemType = paidItem[tr].itemType
              const itemId = paidItem[tr].itemId
              const qty = paidItem[tr].qty
              const price = paidItem[tr].price
              return Number(item?.itemId) === Number(itemId) && item.itemType === itemType && Number(item.qty) === Number(qty)
            })
            return usableVoucher
          })

          if (checkCanUseTr.length !== benefitItems.length) {
            notiError('รายการไม่ครบตามเงื่อนไข')
            return false
          }


          if (treatmentRight.minimum > props.objPayment.totalPrice) {
            notiError(`ราคารวมขั้นต่ำ ${treatmentRight.minimum} บาท 
                รายการ ${_.map(checkCanUseTr, (item) => {
              return (item.itemName)
            })}`)
            return false
          }
        }


        if (benefitPriceUse[benefitBranchId] === undefined) benefitPriceUse[benefitBranchId] = benefitPrice

        if (benefitPriceType === 'SALEPRICE') {
          benefitPriceUse[benefitBranchId] = _.sumBy(checkCanUseTr, 'total') - (benefitPrice || 0)
        } else {
          if (checkCanUseTr.length) {
            if (benefitPriceUnit === 'PERCENT') {
              benefitPriceUse[benefitBranchId] = (_.sumBy(checkCanUseTr, 'total') * (benefitPrice || 0)) / 100
            } else {
              benefitPriceUse[benefitBranchId] = benefitPrice || 0
            }
          } else {
            if (benefitPriceUnit === 'PERCENT') {

              const { discountPromotion, discountVoucher } = props.objPayment
              /** ยอดที่จ่ายปัจจุบัญ */
              /** ยอดคงเหลือที่ต้องจ่าย */
              let balance = props.objPayment.balance + (benefitType === 'promotion' ? discountPromotion || 0 : discountVoucher || 0)
              if (balance < 0) balance = 0
              benefitPriceUse[benefitBranchId] = (Number(balance) * (benefitPrice || 0)) / 100
            } else {
              benefitPriceUse[benefitBranchId] = benefitPrice || 0
            }
          }
        }

        const updatedItemChannel: Record<string, any> = {}
        let benifitBalance = benefitPriceUse[benefitBranchId]
        const benefitBalanceMax = Number(benefitPriceUse[benefitBranchId]) || 0

        const paymentChannelId = benefitType === 'voucher' ? 7 : 8;

        const isItemMatchUsage = (itemType: string) => {
          if (benefitUsage === 'ALL') return true
          if (['OPERATIVE', 'OPERATIVEDF', 'OPERATIVECF'].includes(benefitUsage)) return itemType === 'OPERATIVE'
          if (benefitUsage === 'PRODUCT') return itemType !== 'OPERATIVE'
          return true
        }

        const benefitDataForCalc = { benefitUsage, benefitPriceDF, benefitPriceCF, benefitPriceDFUnit }

        Object.keys(paidItem).forEach((key) => {
          if (benifitBalance <= 0) { benifitBalance = 0 }

          const itemType = paidItem[key].itemType
          if (!isItemMatchUsage(itemType)) {
            updatedItemChannel[key] = { checked: false, disabledChecked: false, disabledInput: true, value: 0, dfAmount: 0, cfAmount: 0 }
            return
          }

          const summaryAmountPaid = getAvailableItemsInChannel(next, Number(paymentChannelId), key,)
          let treatmentPrice = Number(paidItem[key].treatmentPrice) || 0;
          if (props.systemConfig.menu === 'OVERDUE' || props.systemConfig.menu === 'EDIT_PAYMENT') {
            treatmentPrice = treatmentPrice - Number(paidItem[key]?.paid || 0)
          }

          let balance = treatmentPrice - summaryAmountPaid
          if (balance < 0) balance = 0

          let newValue = 0

          if (benifitBalance > 0) {
            if (balance > benifitBalance) {
              newValue = benifitBalance
              benifitBalance = 0
            }
            else {
              newValue = balance
              benifitBalance -= newValue
            }
          }

          const { dfAmount, cfAmount } = calcDfCfForBenefit(newValue, benefitDataForCalc)

          if (checkCanUseTr.length) {
            if (checkCanUseTr.includes(key)) {
              updatedItemChannel[key] = { checked: newValue > 0, disabledChecked: false, disabledInput: false, value: newValue || 0, dfAmount, cfAmount }
            } else {
              updatedItemChannel[key] = { checked: false, disabledChecked: false, disabledInput: true, value: 0, dfAmount: 0, cfAmount: 0 }
            }
          } else {
            updatedItemChannel[key] = { checked: newValue > 0, disabledChecked: false, disabledInput: !newValue, value: newValue, dfAmount, cfAmount }
          }
        })

        const newEntry = {
          ...treatmentRight,
          checked: true,
          disabledChecked: false,
          disabledInput: true,
          amountPaid: 0,
          benefitUsage,
          benefitPriceDF,
          benefitPriceCF,
          benefitPriceDFUnit,
          benefitBalanceMax,
          itemChannel: updatedItemChannel
        }

        if (benefitType === 'voucher' && voucherListId) {
          next = {
            ...props.listOrderPayment,
            vouchers: {
              ...props.listOrderPayment?.vouchers,
              [voucherListId]: newEntry
            }
          }
        } else if (benefitType === 'promotion' && promotionBranchId) {
          next = {
            ...props.listOrderPayment,
            promotions: {
              ...props.listOrderPayment?.promotions,
              [promotionBranchId]: newEntry
            }
          }
        } else {
          next = {
            ...props.listOrderPayment,
            [benefitType]: {
              ...props.listOrderPayment?.[benefitType],
              ...newEntry
            }
          }
        }
      }


    } else {



      /**
  * เคส แบ่งจ่าย
  * คิดเป็น % / ครั้ง
  * คิดเป็น บาท / ครั้ง
  */
      const prevTreatmentRightObj = props.listOrderPayment?.treatmentRight ?? null;
      const prevTreatmentRightPT = prevTreatmentRightObj?.[patientTreatmentRightId] ?? null;
      const checked = prevTreatmentRightPT ? !prevTreatmentRightPT?.checked : true

      const paidItem: Record<string, PaidItem> = props.listOrderPayment?.paid || {}
      const updatedItemChannel: Record<string, any> = {}
      Object.keys(paidItem).forEach((key) => {
        updatedItemChannel[key] = { checked: false, disabledChecked: false, disabledInput: true, value: 0 }
      })

      next = {
        ...props.listOrderPayment,
        treatmentRight: {
          ...props.listOrderPayment?.treatmentRight,
          [patientTreatmentRightId]: {
            patientTreatmentRightId,
            treatmentRightId,
            ...treatmentRight,
            checked: checked, disabledChecked: false, disabledInput: true,
            amountPaid: 0,
            itemChannel: updatedItemChannel
          }
        }
      };

    }

    props.setListOrderPayment(updateSummary(next));
  }, [props.listOrderPayment]);

  /** ห้ามแก้แล้วนะ */
  const handleCheckBoxItemTreatmentRight = useCallback((paymentChannelId: number, patientTreatmentRightId: number, value: any, type: string, id: any) => {
    const itemKey = `${type}_${id}`;

    const prev = props.listOrderPayment;
    if (!prev) return prev;


    const paidItem: Record<string, PaidItem> = prev.paid ?? {};
    const currentPaidItem: PaidItem = paidItem[itemKey];
    if (!currentPaidItem) return prev;
    let treatmentPrice = Number(currentPaidItem.treatmentPrice) || 0;
    if (props.systemConfig.menu === 'OVERDUE' || props.systemConfig.menu === 'EDIT_PAYMENT') {
      treatmentPrice = treatmentPrice - Number(currentPaidItem?.paid || 0)
    }

    const paidChannel = prev.paidChannel?.[paymentChannelId];
    if (!paidChannel) return prev;

    const summaryAmountPaid = getAvailableItemsInChannel(prev, Number(paymentChannelId), itemKey, patientTreatmentRightId)
    const isVoucherChannel = Number(paymentChannelId) === 7;
    const isPromotionChannel = Number(paymentChannelId) === 8;
    const treatmentRight = isVoucherChannel
      ? (prev.vouchers?.[patientTreatmentRightId] ?? {})
      : isPromotionChannel
        ? (prev.promotions?.[patientTreatmentRightId] ?? {})
        : (prev.treatmentRight?.[patientTreatmentRightId] ?? {});
    let maxValue = 0
    if (isVoucherChannel || isPromotionChannel) {
      const balance = Math.max(0, treatmentPrice - summaryAmountPaid)
      const benefitBalanceMax = Number(treatmentRight?.benefitBalanceMax ?? treatmentRight?.voucherPrice ?? treatmentRight?.promotionPrice) || 0
      const usedByOtherItems = _.sumBy(
        Object.entries(treatmentRight?.itemChannel ?? {}).filter(([k]) => k !== itemKey),
        ([, v]: [string, any]) => Number(v?.value) || 0
      )
      const remainingBenefit = Math.max(0, benefitBalanceMax - usedByOtherItems)
      maxValue = Math.min(balance, remainingBenefit)
    }
    const { code, maxValue: trMaxValue } = (isVoucherChannel || isPromotionChannel)
      ? { code: 200, maxValue }
      : getAvailableTreatmentBalance(prev, patientTreatmentRightId, itemKey);
    if (!(isVoucherChannel || isPromotionChannel)) maxValue = trMaxValue

    if (code !== 200) return prev;
    const itemChannel = treatmentRight?.itemChannel ?? {};



    const currentItemChannel =
      itemChannel[itemKey] ?? { checked: false, disabledChecked: false, disabledInput: true, value: 0 };

    const newChecked = !currentItemChannel.checked;
    let newDisabledInput = !newChecked;

    /** ยอดที่จ่ายปัจจุบัญ */
    /** ยอดคงเหลือที่ต้องจ่าย */
    let balance = treatmentPrice - summaryAmountPaid
    if (balance < 0) balance = 0

    const oldChannelValue = Number(currentItemChannel.value) || 0;
    let newValue = newChecked ? oldChannelValue : 0;
    if (newChecked && paymentChannelId === 5) {
      const { isDivide } = treatmentRight

      if (balance > maxValue) newValue = maxValue;
      else newValue = balance;

      newDisabledInput = true;
      if (isDivide === '1') newDisabledInput = false;

    } else if (newChecked && (isVoucherChannel || isPromotionChannel)) {
      if (balance > maxValue) newValue = maxValue;
      else newValue = balance;
      newDisabledInput = false;
    } else if (!newChecked) {
      newValue = 0;
    }



    const newBalance = (newValue >= balance) ? 0 : (balance - newValue)

    const { dfAmount, cfAmount } = (isVoucherChannel || isPromotionChannel)
      ? calcDfCfForBenefit(newValue, treatmentRight)
      : { dfAmount: 0, cfAmount: 0 }

    const baseItemChannel = treatmentRight?.itemChannel ?? {};
    const updateItemBenifit = {
      ...baseItemChannel,
      [itemKey]: {
        ...(baseItemChannel[itemKey] ?? {}),
        checked: newChecked,
        disabledInput: newDisabledInput,
        value: newValue,
        dfAmount,
        cfAmount,
      },
    }

    const summaryAmountPaidBenifit = _.sumBy(Object.values(updateItemBenifit), (it: any) => it.checked ? Number(it?.value) || 0 : 0);
    const updateTreatmentRight = {
      ...treatmentRight,
      amountPaid: summaryAmountPaidBenifit,
      itemChannel: updateItemBenifit,
    };


    const updatedItemChannel = {
      ...itemChannel,
      [itemKey]: {
        ...currentItemChannel,
        checked: checkCheckedTreatmentRight(prev.treatmentRight, patientTreatmentRightId),
        disabledInput: newDisabledInput,
        value: newValue,
        dfAmount,
        cfAmount,
      },
    };

    const updatedPaid = {
      ...paidItem,
      [itemKey]: {
        ...currentPaidItem,
        value: newValue,
        balance: newBalance,
      },
    };

    // อัปเดต amountPaid ของช่องทางให้ตรง
    const amountPaid = _.sumBy(Object.values(updatedItemChannel), (it: any) => it.checked ? Number(it?.value) || 0 : 0);

    const updatedPaidChannel = {
      ...paidChannel,
      itemChannel: updatedItemChannel,
      amountPaid,
    };

    const next = isVoucherChannel
      ? {
        ...prev,
        paid: updatedPaid,
        paidChannel: { ...prev.paidChannel, [paymentChannelId]: updatedPaidChannel },
        vouchers: { ...prev.vouchers, [patientTreatmentRightId]: updateTreatmentRight },
      }
      : isPromotionChannel
        ? {
          ...prev,
          paid: updatedPaid,
          paidChannel: { ...prev.paidChannel, [paymentChannelId]: updatedPaidChannel },
          promotions: { ...prev.promotions, [patientTreatmentRightId]: updateTreatmentRight },
        }
        : {
          ...prev,
          paid: updatedPaid,
          paidChannel: { ...prev.paidChannel, [paymentChannelId]: updatedPaidChannel },
          treatmentRight: { ...prev.treatmentRight, [patientTreatmentRightId]: updateTreatmentRight },
        };



    props.setListOrderPayment(updateSummary(next));
  }, [props.listOrderPayment, props.setListOrderPayment]);




  const handleValuePaidItem = useCallback(
    (paymentChannelId: number, value: any, type: string, id: any) => {
      const itemKey = `${type}_${id}`;

      const prev = props.listOrderPayment;
      if (!prev) return prev;

      const itemPaid: PaidItem = prev.paid?.[itemKey];
      let treatmentPrice = itemPaid?.treatmentPrice ?? 0;
      if (props.systemConfig.menu === 'OVERDUE' || props.systemConfig.menu === 'EDIT_PAYMENT') {
        treatmentPrice = Number(itemPaid?.treatmentPrice) - Number(itemPaid?.paid || 0)
      }

      const paidChannel = prev.paidChannel?.[paymentChannelId];

      if (!paidChannel) return prev;

      const itemChannel = paidChannel.itemChannel ?? {};
      const currentItemChannel =
        itemChannel[itemKey] ?? { checked: false, disabledChecked: false, disabledInput: true, value: 0 };

      const oldPaid = Number(currentItemChannel.value) || 0;

      const totalPaid = Number(itemPaid?.value) || 0;

      // Normalize input
      let normalizedValue = Number(value);
      if (!Number.isFinite(normalizedValue)) normalizedValue = 0;
      if (normalizedValue < 0) normalizedValue = 0;

      const summaryAmountPaid = getAvailableItemsInChannel(prev, Number(paymentChannelId), itemKey)
      const balanceBefore = Math.max(0, treatmentPrice - summaryAmountPaid);


      if (normalizedValue > balanceBefore) normalizedValue = balanceBefore;

      // balance ใหม่ควรผูกกับยอดรวมใหม่โดยตรง
      const newBalance = Math.max(0, balanceBefore - normalizedValue);

      const updatedItemChannel = {
        ...itemChannel,
        [itemKey]: { ...currentItemChannel, value: normalizedValue },
      };

      const updatedPaid = {
        ...prev.paid,
        [itemKey]: { ...prev.paid?.[itemKey], value: normalizedValue, balance: newBalance },
      };

      const amountPaid = _.sumBy(Object.values(updatedItemChannel), (it: any) => Number(it?.value) || 0);

      const updatedPaidChannel = {
        ...paidChannel,
        itemChannel: updatedItemChannel,
        amountPaid,
      };


      const next = {
        ...prev,
        paid: updatedPaid,
        paidChannel: {
          ...prev.paidChannel,
          [paymentChannelId]: updatedPaidChannel,
        },
      };



      props.setListOrderPayment(updateSummary(next));


    },
    [props.listOrderPayment, props.setListOrderPayment]
  );


  const handleValuePaidTreatmentRightItem = useCallback((paymentChannelId: number, value: any, type: string, id: any, patientTreatmentRightId: number) => {
    const itemKey = `${type}_${id}`;

    // Normalize input
    let newValue = Number(value);
    if (!Number.isFinite(newValue)) newValue = 0;
    if (newValue < 0) newValue = 0;


    const prev = props.listOrderPayment;
    if (!prev) return prev;


    const paidItem: Record<string, PaidItem> = prev.paid ?? {};
    const currentPaidItem: PaidItem = paidItem[itemKey];
    if (!currentPaidItem) return prev;
    let treatmentPrice = Number(currentPaidItem.treatmentPrice) || 0;
    if (props.systemConfig.menu === 'OVERDUE' || props.systemConfig.menu === 'EDIT_PAYMENT') {
      treatmentPrice = Number(currentPaidItem?.treatmentPrice) - Number(currentPaidItem?.paid || 0)
    }

    const paidChannel = prev.paidChannel?.[paymentChannelId];
    if (!paidChannel) return prev;

    const summaryAmountPaid = getAvailableItemsInChannel(prev, Number(paymentChannelId), itemKey, patientTreatmentRightId)
    const isVoucherChannel = Number(paymentChannelId) === 7;
    const isPromotionChannel = Number(paymentChannelId) === 8;
    const treatmentRight = isVoucherChannel ? (prev.vouchers?.[patientTreatmentRightId] ?? {}) : isPromotionChannel ? (prev.promotions?.[patientTreatmentRightId] ?? {}) : (prev.treatmentRight?.[patientTreatmentRightId] ?? {});
    let maxValue = 0
    if (isVoucherChannel || isPromotionChannel) {
      const balance = Math.max(0, treatmentPrice - summaryAmountPaid)
      const benefitBalanceMax = Number(treatmentRight?.benefitBalanceMax ?? treatmentRight?.voucherPrice ?? treatmentRight?.promotionPrice) || 0
      const usedByOtherItems = _.sumBy(
        Object.entries(treatmentRight?.itemChannel ?? {}).filter(([k]) => k !== itemKey),
        ([, v]: [string, any]) => Number(v?.value) || 0
      )
      const remainingBenefit = Math.max(0, benefitBalanceMax - usedByOtherItems)
      maxValue = Math.min(balance, remainingBenefit)
    }
    const { code, maxValue: trMaxValue } = (isVoucherChannel || isPromotionChannel)
      ? { code: 200, maxValue }
      : getAvailableTreatmentBalance(prev, patientTreatmentRightId, itemKey);
    if (!(isVoucherChannel || isPromotionChannel)) maxValue = trMaxValue

    if (code !== 200) return prev;
    const itemChannel = treatmentRight?.itemChannel ?? {};



    const currentItemChannel =
      itemChannel[itemKey] ?? { checked: false, disabledChecked: false, disabledInput: true, value: 0 };

    const checked = currentItemChannel.checked;

    /** ยอดที่จ่ายปัจจุบัญ */
    /** ยอดคงเหลือที่ต้องจ่าย */
    let balance = treatmentPrice - summaryAmountPaid
    if (balance < 0) balance = 0

    // // ถ้า uncheck ให้คืนยอดช่องนี้เป็น 0

    if (checked && paymentChannelId === 5) {
      const { isDivide } = treatmentRight
      if (balance > maxValue) balance = maxValue;
      if (newValue > balance) newValue = balance;
    }
    if ((isVoucherChannel || isPromotionChannel) && newValue > maxValue) newValue = maxValue;

    // ✅ FIX: คำนวณยอดรวมที่จ่ายจากทุกช่องทาง (รวมสิทธิการรักษาทั้งหมด)
    const totalPaidForItem = summaryAmountPaid + newValue
    const newBalance = Math.max(0, treatmentPrice - totalPaidForItem)

    const { dfAmount: newDfAmount, cfAmount: newCfAmount } = (isVoucherChannel || isPromotionChannel)
      ? calcDfCfForBenefit(newValue, treatmentRight)
      : { dfAmount: 0, cfAmount: 0 }

    const updateItemBenifit = {
      ...(treatmentRight?.itemChannel ?? {}),
      [itemKey]: {
        ...(treatmentRight?.itemChannel?.[itemKey] ?? {}),
        value: newValue,
        checked: newValue > 0,
        dfAmount: newDfAmount,
        cfAmount: newCfAmount,
      },
    }

    console.log('updateItemBenifit', updateItemBenifit)

    const summaryAmountPaidBenifit = _.sumBy(Object.values(updateItemBenifit), (it: any) => it.checked ? Number(it?.value) || 0 : 0);
    const updateTreatmentRight = {
      ...treatmentRight,
      amountPaid: summaryAmountPaidBenifit,
      itemChannel: updateItemBenifit,
    };


    const updatedItemChannel = {
      ...itemChannel,
      [itemKey]: {
        ...currentItemChannel,
        checked: checkCheckedTreatmentRight(prev.treatmentRight, patientTreatmentRightId),
        value: newValue,
      },
    };

    // ✅ FIX: ใช้ยอดรวมจากทุกช่องทาง แทนที่จะเป็นแค่ยอดของสิทธิการรักษาเดียว
    const updatedPaid = {
      ...paidItem,
      [itemKey]: {
        ...currentPaidItem,
        value: totalPaidForItem,
        balance: newBalance,
      },
    };

    // ✅ FIX: คำนวณ amountPaid จาก treatmentRight ทั้งหมด ไม่ใช่แค่ updatedItemChannel
    const totalTreatmentRightAmount = Object.values({ ...prev.treatmentRight, [patientTreatmentRightId]: updateTreatmentRight })
      .filter((tr: any) => tr.checked)
      .reduce((sum: number, tr: any) => {
        const trAmount = _.sumBy(Object.values(tr.itemChannel || {}), (it: any) =>
          it.checked ? Number(it?.value) || 0 : 0
        )
        return sum + trAmount
      }, 0)

    const amountPaid = totalTreatmentRightAmount;

    const updatedPaidChannel = {
      ...paidChannel,
      itemChannel: updatedItemChannel,
      amountPaid,
    };

    const next = isVoucherChannel
      ? {
        ...prev,
        paid: updatedPaid,
        paidChannel: { ...prev.paidChannel, [paymentChannelId]: updatedPaidChannel },
        vouchers: { ...prev.vouchers, [patientTreatmentRightId]: updateTreatmentRight },
      }
      : isPromotionChannel
        ? {
          ...prev,
          paid: updatedPaid,
          paidChannel: { ...prev.paidChannel, [paymentChannelId]: updatedPaidChannel },
          promotions: { ...prev.promotions, [patientTreatmentRightId]: updateTreatmentRight },
        }
        : {
          ...prev,
          paid: updatedPaid,
          paidChannel: { ...prev.paidChannel, [paymentChannelId]: updatedPaidChannel },
          treatmentRight: { ...prev.treatmentRight, [patientTreatmentRightId]: updateTreatmentRight },
        };

    props.setListOrderPayment(updateSummary(next));
  }, [props.listOrderPayment, props.setListOrderPayment]);

  const getAvailableItemsInChannel = useCallback((prev: any, paymentChannelId: number, itemKey: string, patientTreatmentRightId?: number) => {
    if (!prev) return 0;
    const { paidChannel, treatmentRight, vouchers, promotions } = prev;
    let amountPaid = 0;
    for (const key in paidChannel) {
      if (Number(key) === paymentChannelId) continue;
      if (Number(key) === 5) continue;
      if (paidChannel[key].itemChannel[itemKey]) {
        amountPaid += Number(paidChannel[key].itemChannel[itemKey].value) || 0;
      }
    }

    if (treatmentRight)
      for (const treatmentRightKey in treatmentRight) {

        if (Number(treatmentRightKey) === patientTreatmentRightId) continue;

        const treatmentRightItem = treatmentRight[treatmentRightKey]
        if (treatmentRightItem && Number(treatmentRightKey) !== patientTreatmentRightId && treatmentRightItem.checked) {
          amountPaid += Number(treatmentRightItem?.itemChannel?.[itemKey]?.value) || 0;
        }
      }

    if (Number(paymentChannelId) === 7 && vouchers) {
      Object.entries(vouchers).forEach(([vId, v]: [string, any]) => {
        if (patientTreatmentRightId != null && Number(vId) === Number(patientTreatmentRightId)) return;
        amountPaid += Number(v?.itemChannel?.[itemKey]?.value) || 0;
      });
    }
    if (Number(paymentChannelId) === 8 && promotions) {
      Object.entries(promotions).forEach(([pId, p]: [string, any]) => {
        if (patientTreatmentRightId != null && Number(pId) === Number(patientTreatmentRightId)) return;
        amountPaid += Number(p?.itemChannel?.[itemKey]?.value) || 0;
      });
    }
    return amountPaid;
  }, [props.listOrderPayment]);

  const handleRemovePromotion = useCallback((promotionBranchId: number) => {
    const prev = props.listOrderPayment;
    if (!prev?.promotions?.[promotionBranchId]) return;
    const nextPromotions = { ...prev.promotions };
    delete nextPromotions[promotionBranchId];
    const next = { ...prev, promotions: nextPromotions, promotion: {} };
    props.setListOrderPayment(updateSummary(next));
  }, [props.listOrderPayment, props.setListOrderPayment]);

  const handleRemoveVoucher = useCallback((voucherListId: number) => {
    const prev = props.listOrderPayment;
    if (!prev?.vouchers?.[voucherListId]) return;
    const nextVouchers = { ...prev.vouchers };
    delete nextVouchers[voucherListId];
    const next = { ...prev, vouchers: nextVouchers, voucher: {} };
    props.setListOrderPayment(updateSummary(next));
  }, [props.listOrderPayment, props.setListOrderPayment]);

  const getAvailableTreatmentBalance = useCallback((prev: any, patientTreatmentRightId: number, itemKey: string) => {
    if (!prev) return { code: 400, maxValue: 0 };
    const treatmentRight = prev.treatmentRight?.[patientTreatmentRightId];
    const paidItem: Record<string, PaidItem> = prev?.paid;
    const itemChannel = treatmentRight?.itemChannel;
    let valueTreatmentRight = 0;
    if (treatmentRight) {

      const { isDivide, balance, price: treatmentRightPrice, itemChannel } = treatmentRight;

      let otherItemChannel = 0
      Object.keys(itemChannel).forEach((key: any) => {
        if (key !== itemKey && itemChannel[key].checked && itemChannel[key].value > 0) {
          otherItemChannel += Number(itemChannel[key].value) || 0;
        }
      })

      /** 
       * เช็คยอดที่จ่ายได้จากสิทธิ 
       *  เงื่อนไข % ใช้ได้แค่ 1 รายการเท่านั้น
       *  เงื่อนไข บาท/ครั้ง ใช้ได้แค่ 1 รายการเท่านั้น
       *  เงื่อนไข บาท แบ่งจ่าย ใช้ได้แค่ หลายรายการ รายการเท่านั้น
      */

      if (isDivide === '1')
        valueTreatmentRight = balance;
      else {
        // check used treatment right
        const useTreatmentRight = Object.keys(itemChannel).filter((key: any) => {
          const item = itemChannel[key]
          return key !== itemKey && item.checked && item.value > 0;
        })
        if (useTreatmentRight.length > 0) return { code: 400, maxValue: 0 }

        if (treatmentRight.unit === "BAHT")
          valueTreatmentRight = treatmentRightPrice;
        else {
          const summaryAmountPaid = getAvailableItemsInChannel(prev, 5, itemKey, patientTreatmentRightId)
          const currentPaidItem = paidItem[itemKey]
          let treatmentPrice = Number(currentPaidItem.treatmentPrice) || 0;
          if (props.systemConfig.menu === 'OVERDUE' || props.systemConfig.menu === 'EDIT_PAYMENT') {
            treatmentPrice = Number(currentPaidItem?.treatmentPrice) - Number(currentPaidItem?.paid || 0)
          }

          const itemBalance = treatmentPrice - summaryAmountPaid
          valueTreatmentRight = itemBalance * (treatmentRightPrice / 100)
        }
      }

      valueTreatmentRight = valueTreatmentRight - otherItemChannel;
    }

    const maxValue = valueTreatmentRight;

    return { code: 200, maxValue };
  }, [props.listOrderPayment]);

  function calculateChange(paid: number, price: number): number {
    return Math.min(Math.max(paid - price, 0), 1000)
  }

  const handleValueChannel = useCallback((paymentChannelId: number, e: any) => {
    let remainingAmount = Number(e.target.value);
    if (!Number.isFinite(remainingAmount) || remainingAmount < 0) remainingAmount = 0;

    const prev = props.listOrderPayment;
    if (!prev) return prev;

    const paidChannelMain = prev.paidChannel;
    const paidChannel = paidChannelMain?.[paymentChannelId];
    if (!paidChannel) return prev;

    // สำหรับเงินสด (paymentChannelId === 1) อนุญาตให้จ่ายเกินได้
    const isCash = paymentChannelId === 1;

    if (paymentChannelId === 6) {
      const advanceUsed = remainingAmount;
      if (advanceUsed > props.advanceBalance) remainingAmount = props.advanceBalance;
    }

    const itemChannel = paidChannel?.itemChannel || {}
    const paidItem: Record<string, PaidItem> = { ...prev.paid }

    // Normalize value 
    const updatedItemChannel: Record<string, any> = { ...itemChannel }

    let finalAmountPaid = 0
    const originalRemainingAmount = remainingAmount; // เก็บยอดเดิมไว้สำหรับคำนวณเงินทอน

    // Distribute sequentially across checked items (stop when remainingAmount exhausted) 
    let updatedPaid: Record<string, PaidItem> = { ...prev.paid }
    Object.keys(itemChannel).forEach((itemKey, index: number) => {

      /** รายการรวม */
      const currentPaidItem = paidItem[itemKey]
      let treatmentPrice = Number(currentPaidItem.treatmentPrice) || 0;
      if (props.systemConfig.menu === 'OVERDUE' || props.systemConfig.menu === 'EDIT_PAYMENT') {
        treatmentPrice = Number(currentPaidItem?.treatmentPrice) - Number(currentPaidItem?.paid || 0)
      }

      /** รายการในช่อทางที่แก้ไข */
      const item = itemChannel[itemKey]
      let checked = item?.checked || false
      let disabledChecked = item?.disabledChecked || false
      let disabledInput = item?.disabledInput || false
      const prevValue = Number(item.value || 0)  // ยอดที่จ่ายในช่องทางนี้ก่อนหน้า

      /** ยอดที่จ่ายปัจจุบัญ */
      /** ยอดคงเหลือที่ต้องจ่าย */
      let balance = treatmentPrice - getAvailableItemsInChannel(prev, Number(paymentChannelId), itemKey)
      if (balance <= 0) balance = 0

      // คำนวณ value ใหม่ในช่องทางนี้
      // สำหรับเงินสด: แต่ละรายการไม่เกินยอดคงเหลือ แต่ยอดรวมช่องทางสามารถเกินได้
      // สำหรับช่องทางอื่น: จำกัดตามเดิม
      let newValue = 0
      if (remainingAmount > 0) {
        if (isCash) {
          // เงินสด: แต่ละรายการไม่เกินยอดคงเหลือ
          newValue = Math.min(remainingAmount, balance)
        } else {
          // ช่องทางอื่น: จำกัดตามเดิม
          if (remainingAmount < balance) newValue = remainingAmount
          else if (remainingAmount >= balance) newValue = balance
        }
      }

      const newTotalPaid = newValue
      const newBalance = (newTotalPaid >= balance) ? 0 : (balance - newTotalPaid)

      if (newValue > 0) {
        checked = true
        disabledChecked = false
        disabledInput = false
      } else {
        checked = false
        disabledChecked = false
        disabledInput = true
      }
      // อัพเดต itemChannel

      const dccAmount = getDccFromListOrder(item?.id, item?.type)
      updatedItemChannel[itemKey] = {
        ...item,
        value: newValue,
        dccAmount: dccAmount
      }
      updatedPaid = {
        ...updatedPaid,
        [itemKey]: { ...prev.paid?.[itemKey], value: newValue, balance: newBalance },
      };

      // อัพเดต paid item
      paidItem[itemKey] = { ...paidItem[itemKey], value: newTotalPaid, balance: newBalance }
      itemChannel[itemKey] = { ...itemChannel[itemKey], value: newValue, checked: checked, disabledChecked: disabledChecked, disabledInput: disabledInput, dccAmount: dccAmount }

      // ลด remainingAmount ตามยอดที่จ่ายจริง
      remainingAmount -= newValue
      finalAmountPaid += newValue
    })

    if (isCash) {
      let amountChange = 0
      if (originalRemainingAmount > finalAmountPaid) {
        amountChange = calculateChange(originalRemainingAmount, finalAmountPaid)
        if (amountChange > 1000) amountChange = 1000 - (originalRemainingAmount % finalAmountPaid)

        const modChange = (originalRemainingAmount % finalAmountPaid)
        const divisionOrg = Math.floor(originalRemainingAmount / 1000)
        const divisionFinal = Math.floor(finalAmountPaid / 1000)

        if (divisionOrg > (divisionFinal + 1)) {
          amountChange = ((divisionFinal + 1) * 1000) % finalAmountPaid
        } else if (divisionOrg !== divisionFinal) {
          amountChange = modChange
        }

        finalAmountPaid = finalAmountPaid + amountChange
      }
      props.setObjPayment((prev: any) => ({ ...prev, amountChange: amountChange }))
    }
    // สำหรับเงินสด: เก็บยอดที่จ่ายจริง (อาจน้อยกว่าที่กรอกถ้ามีเงินทอน)
    const updatedPaidChannel = {
      ...paidChannel,
      amountPaid: finalAmountPaid,
      itemChannel: itemChannel,
    }

    const next = {
      ...prev,
      paid: paidItem,
      paidChannel: { ...prev?.paidChannel, [paymentChannelId]: { ...updatedPaidChannel } }
    }


    props.setListOrderPayment(updateSummary(next));

  }, [props.listOrderPayment, props.setListOrderPayment]);

  const handleChangValueTreatmentRight = useCallback((paymentChannelId: number, patientTreatmentRightId: number, value: any) => {

    let remainingAmount = Number(value);
    if (!Number.isFinite(remainingAmount) || remainingAmount < 0) remainingAmount = 0;
    const prev = props.listOrderPayment;
    if (!prev) return prev;

    const paidChannel = prev.paidChannel?.[paymentChannelId];
    if (!paidChannel) return prev;

    const isVoucher = Number(paymentChannelId) === 7;
    const isPromotion = Number(paymentChannelId) === 8;
    const itemChannel = paidChannel.itemChannel ?? {};
    const itemChannelTreatmentRight = isVoucher
      ? (prev.vouchers?.[patientTreatmentRightId]?.itemChannel || {})
      : isPromotion
        ? (prev.promotions?.[patientTreatmentRightId]?.itemChannel || {})
        : (prev.treatmentRight?.[patientTreatmentRightId]?.itemChannel || {})
    const paidItem: Record<string, PaidItem> = { ...prev.paid }


    // Normalize value 
    const updatedItemChannel: Record<string, any> = { ...itemChannelTreatmentRight }

    let finalAmountPaid = 0

    // Distribute sequentially across checked items (stop when remainingAmount exhausted) 
    Object.keys(itemChannelTreatmentRight).forEach((itemKey) => {

      /** รายการรวม */
      const currentPaidItem = paidItem[itemKey]
      const currentPaidItemValue = Number(currentPaidItem.value || 0)
      let treatmentPrice = Number(currentPaidItem.treatmentPrice || 0)
      if (props.systemConfig.menu === 'OVERDUE' || props.systemConfig.menu === 'EDIT_PAYMENT') {
        treatmentPrice = Number(currentPaidItem?.treatmentPrice) - Number(currentPaidItem?.paid || 0)
      }

      /** รายการในช่อทางที่แก้ไข */
      const item = itemChannelTreatmentRight[itemKey]
      let checked = item?.checked || false
      let disabledChecked = item?.disabledChecked || false
      let disabledInput = item?.disabledInput || false
      const prevValue = Number(item.value || 0)  // ยอดที่จ่ายในช่องทางนี้ก่อนหน้า
      const summaryAmountPaid = getAvailableItemsInChannel(prev, Number(paymentChannelId), itemKey, patientTreatmentRightId)

      /** ยอดที่จ่ายปัจจุบัญ */
      /** ยอดคงเหลือที่ต้องจ่าย */
      let balance = treatmentPrice - summaryAmountPaid
      if (balance < 0) balance = 0


      // คำนวณ value ใหม่ในช่องทางนี้ (oldValue + actualPaid) 
      let newValue = 0
      if (remainingAmount > 0 && remainingAmount < balance) newValue = remainingAmount
      else if (remainingAmount > balance) newValue = balance


      const newTotalPaid = newValue
      const newBalance = (newTotalPaid >= balance) ? 0 : (balance - newTotalPaid)


      if (newValue > 0) {
        checked = true
        disabledChecked = false
        disabledInput = false
      } else {
        checked = false
        disabledChecked = false
        disabledInput = true
      }
      // อัพเดต itemChannel
      updatedItemChannel[itemKey] = {
        ...item,
        value: newValue
      }


      // อัพเดต paid item
      itemChannelTreatmentRight[itemKey] = { ...itemChannelTreatmentRight[itemKey], value: newValue, checked: checked, disabledChecked: disabledChecked, disabledInput: disabledInput }



      // อัพเดต paid item
      paidItem[itemKey] = { ...paidItem[itemKey], value: newTotalPaid, balance: newBalance }
      itemChannel[itemKey] = { ...itemChannel[itemKey], value: newValue, checked: checked, disabledChecked: disabledChecked, disabledInput: disabledInput }

      // ลด remainingAmount ตามยอดที่จ่ายจริง
      remainingAmount -= newValue
      finalAmountPaid += newValue
    })


    const updatedPaidChannel = {
      ...paidChannel,
      amountPaid: finalAmountPaid,
      itemChannel: itemChannel,
    }

    const next = isVoucher
      ? {
        ...prev,
        paid: paidItem,
        paidChannel: { ...prev?.paidChannel, [paymentChannelId]: updatedPaidChannel },
        vouchers: {
          ...prev?.vouchers,
          [patientTreatmentRightId]: {
            ...prev?.vouchers?.[patientTreatmentRightId],
            itemChannel: itemChannelTreatmentRight,
            amountPaid: finalAmountPaid,
          }
        }
      }
      : isPromotion
        ? {
          ...prev,
          paid: paidItem,
          paidChannel: { ...prev?.paidChannel, [paymentChannelId]: updatedPaidChannel },
          promotions: {
            ...prev?.promotions,
            [patientTreatmentRightId]: {
              ...prev?.promotions?.[patientTreatmentRightId],
              itemChannel: itemChannelTreatmentRight,
              amountPaid: finalAmountPaid,
            }
          }
        }
        : {
          ...prev,
          paid: paidItem,
          paidChannel: { ...prev?.paidChannel, [paymentChannelId]: updatedPaidChannel },
          treatmentRight: {
            ...prev?.treatmentRight,
            [patientTreatmentRightId]: {
              ...prev?.treatmentRight?.[patientTreatmentRightId],
              itemChannel: itemChannelTreatmentRight,
              amountPaid: finalAmountPaid,
            }
          }
        };

    props.setListOrderPayment(updateSummary(next));

  }, [props.listOrderPayment, props.setListOrderPayment, props.setObjPayment]);


  const getPaidItemBenefit = (itemChannel: any, paidItem: any) => {
    const paidItemBenefit: any = {}

    let amountPaid = 0

    for (const keyItem of Object.keys(itemChannel)) {
      if (!paidItem[keyItem]) paidItem[keyItem] = 0
      const item = itemChannel[keyItem]
      if (!paidItemBenefit[keyItem]) paidItemBenefit[keyItem] = { value: 0, checked: false }
      if (item.checked) {
        paidItem[keyItem] += Number(item.value)
        paidItemBenefit[keyItem].value += Number(item.value)
        paidItemBenefit[keyItem].checked = true
        amountPaid += Number(item.value)
      }
    }

    return { paidItem, paidItemBenefit, amountPaid }
  }
  const updateSummary = (next?: any) => {
    const { paid, paidChannel, treatmentRight, promotion, promotions, voucher, vouchers } = next || props.listOrderPayment;
    const vouchersMap = vouchers && Object.keys(vouchers).length ? vouchers : (voucher?.voucherListId ? { [voucher.voucherListId]: voucher } : {});
    const promotionsMap = promotions && Object.keys(promotions).length ? promotions : (promotion?.promotionBranchId ? { [promotion.promotionBranchId]: promotion } : {});

    const channelBenifit = [5, 7, 8]
    const paidItem: any = {}
    const balanceItem: any = {}
    const paidItemTreatmentRight: any = {}
    const paidItemBenefit: any = {}
    if (treatmentRight)
      Object.keys(treatmentRight).forEach((key: any) => {
        const itemChannel = treatmentRight[key].itemChannel ?? {};
        for (const keyItem of Object.keys(itemChannel)) {
          if (!paidItem[keyItem]) paidItem[keyItem] = 0
          const item = itemChannel[keyItem]
          if (!paidItemTreatmentRight[keyItem]) paidItemTreatmentRight[keyItem] = { value: 0, checked: false }
          if (item.checked) {
            paidItem[keyItem] += Number(item.value)
            paidItemTreatmentRight[keyItem].value += Number(item.value)
            paidItemTreatmentRight[keyItem].checked = true
          }
        }
      })
    if (Object.keys(promotionsMap).length) {
      const mergedBenefit8: any = {}
      Object.values(promotionsMap).forEach((p: any) => {
        if (!p?.promotionBranchId) return
        const itemChannel = p.itemChannel ?? {}
        const { paidItem: nextPaidItem, paidItemBenefit: item, amountPaid } = getPaidItemBenefit(itemChannel, paidItem)
        p.amountPaid = amountPaid
        Object.keys(item || {}).forEach((keyItem) => {
          if (!mergedBenefit8[keyItem]) mergedBenefit8[keyItem] = { value: 0, checked: false }
          mergedBenefit8[keyItem].value += Number(item[keyItem]?.value) || 0
          if (item[keyItem]?.checked) mergedBenefit8[keyItem].checked = true
        })
      })
      paidItemBenefit[8] = mergedBenefit8
    }
    if (Object.keys(vouchersMap).length) {
      const mergedBenefit7: any = {}
      Object.values(vouchersMap).forEach((v: any) => {
        if (!v?.voucherListId) return
        const itemChannel = v.itemChannel ?? {}
        const { paidItem: nextPaidItem, paidItemBenefit: item, amountPaid } = getPaidItemBenefit(itemChannel, paidItem)
        v.amountPaid = amountPaid
        Object.keys(item || {}).forEach((keyItem) => {
          if (!mergedBenefit7[keyItem]) mergedBenefit7[keyItem] = { value: 0, checked: false }
          mergedBenefit7[keyItem].value += Number(item[keyItem]?.value) || 0
          if (item[keyItem]?.checked) mergedBenefit7[keyItem].checked = true
        })
      })
      paidItemBenefit[7] = mergedBenefit7
    }

    Object.keys(paidChannel).forEach((key: any) => {

      if (!channelBenifit.includes(Number(key))) {
        const itemChannel = paidChannel[key].itemChannel ?? {};
        for (const keyItem of Object.keys(itemChannel)) {
          if (!paidItem[keyItem]) paidItem[keyItem] = 0
          const item = itemChannel[keyItem]
          if (item.checked) {
            paidItem[keyItem] += Number(item.value)
          } else {
            paidItem[keyItem] += 0
          }
        }
      } else {

        const itemChannel = paidChannel[key].itemChannel ?? {};
        if (Number(key) === 5 && itemChannel && treatmentRight) {
          // ✅ FIX: คำนวณ amountPaid จาก treatmentRight ทั้งหมด
          let totalTreatmentRightAmount = 0
          for (const keyItem of Object.keys(itemChannel)) {
            const item = itemChannel[keyItem]
            const { value, checked } = paidItemTreatmentRight?.[keyItem] ?? { ...item }
            /** รายการในช่องทางที่ 5 จ่ายเท่าไหร่ */
            paidChannel[key].itemChannel[keyItem] = { ...item, value: value, checked: checked }
          }

          // ✅ FIX: คำนวณยอดรวมจาก treatmentRight ทั้งหมด
          Object.keys(treatmentRight).forEach((trKey: any) => {
            const tr = treatmentRight[trKey]
            if (tr && tr.checked) {
              const trAmount = _.sumBy(Object.values(tr.itemChannel || {}), (it: any) =>
                it.checked ? Number(it?.value) || 0 : 0
              )
              totalTreatmentRightAmount += trAmount
            }
          })

          paidChannel[key].amountPaid = totalTreatmentRightAmount
          paidChannel[key].checked = totalTreatmentRightAmount > 0
        } else if (Number(key) === 8 && Object.keys(promotionsMap).length) {
          let paidPromotion = 0
          const mergedItemChannel8 = paidChannel[key].itemChannel ?? {}
          for (const keyItem of Object.keys(mergedItemChannel8)) {
            const { value, checked } = paidItemBenefit[8]?.[keyItem] ?? { value: 0, checked: false }
            paidChannel[key].itemChannel[keyItem] = { ...mergedItemChannel8[keyItem], value, checked }
            paidPromotion += Number(value)
          }
          paidChannel[key].amountPaid = paidPromotion
          paidChannel[key].checked = paidPromotion > 0
          paidChannel[key].disabledInput = true
        } else if (Number(key) === 7 && Object.keys(vouchersMap).length) {
          let paidVoucher = 0
          const mergedItemChannel = paidChannel[key].itemChannel ?? {}
          for (const keyItem of Object.keys(mergedItemChannel)) {
            const { value, checked } = paidItemBenefit[7]?.[keyItem] ?? { value: 0, checked: false }
            paidChannel[key].itemChannel[keyItem] = { ...mergedItemChannel[keyItem], value, checked }
            paidVoucher += Number(value)
          }
          paidChannel[key].amountPaid = paidVoucher
          paidChannel[key].checked = paidVoucher > 0
          paidChannel[key].disabledInput = true
        } else {
          for (const keyItem of Object.keys(paidChannel[key].itemChannel)) {
            const item = paidChannel[key].itemChannel[keyItem]
            paidChannel[key].itemChannel[keyItem] = { ...item, value: 0, checked: false }
          }
          paidChannel[key].amountPaid = 0
          paidChannel[key].checked = false
          paidChannel[key].disabledInput = false

        }
      }
    })

    for (const itemKey in paid) {

      /** 
       *  ต้องการอัพเดตยอดที่จ่ายของรายการนั้นๆ
       * key = รหัสรายการ
       * paid[key] =  {balance: 0, treatmentPrice: 0, value: 0} รายละเอียดรายการ
       * paidItem = แต่ละช่องทางจ่ายเท่าไหร่
       */
      if (paid[itemKey]) {
        let treatmentPrice = Number(paid[itemKey].treatmentPrice || 0)
        if (props.systemConfig.menu === 'OVERDUE' || props.systemConfig.menu === 'EDIT_PAYMENT') {
          treatmentPrice = Number(paid[itemKey]?.treatmentPrice) - Number(paid[itemKey]?.paid || 0)
        }


        let balance = treatmentPrice - paidItem[itemKey]
        if (balance < 0) balance = 0
        paid[itemKey].value = paidItem[itemKey]
        paid[itemKey].balance = balance
      }
    }

    if (props.systemConfig.menu === 'OVERDUE') {
      const applyOverdueItemLock = (itemChannelMap: Record<string, any> = {}) => {
        Object.keys(itemChannelMap).forEach((itemKey) => {
          const paidItem = paid?.[itemKey]
          if (!paidItem) return
          const shouldLock = Number(paidItem.paid || 0) >= Number(paidItem.treatmentPrice || 0)
          if (!shouldLock) return
          itemChannelMap[itemKey] = {
            ...itemChannelMap[itemKey],
            checked: false,
            disabledChecked: true,
            disabledInput: true,
            value: 0
          }
        })
      }

      Object.keys(paidChannel || {}).forEach((channelKey: any) => {
        applyOverdueItemLock(paidChannel[channelKey]?.itemChannel)
      })

      Object.keys((next?.treatmentRight || {})).forEach((trKey: any) => {
        applyOverdueItemLock(next?.treatmentRight?.[trKey]?.itemChannel)
      })
      Object.keys((next?.promotions || {})).forEach((promotionKey: any) => {
        applyOverdueItemLock(next?.promotions?.[promotionKey]?.itemChannel)
      })
      Object.keys((next?.vouchers || {})).forEach((voucherKey: any) => {
        applyOverdueItemLock(next?.vouchers?.[voucherKey]?.itemChannel)
      })
      if (next?.promotion?.itemChannel) applyOverdueItemLock(next.promotion.itemChannel)
      if (next?.voucher?.itemChannel) applyOverdueItemLock(next.voucher.itemChannel)
    }

    return {
      ...next,
      paid,
      paidChannel,
      promotion: next?.promotion,
      promotions: next?.promotions,
      voucher: next?.voucher,
      vouchers: next?.vouchers
    }
  }

  const renderChannel = useCallback((paymentChannel: any) => {
    const { channelIndex, key, paymentChanel: paymentChannelId, bank } = paymentChannel
    if (!paymentChannel.isActive) return null

    // Cache paidChannel to avoid repeated access
    const paidChannel = props.listOrderPayment?.paidChannel?.[paymentChannelId] || {}
    const itemChannel = paidChannel?.itemChannel || {}

    const index = channelIndex ? `${channelIndex}. ` : ''

    const title = <UseStyled.TitlePayment>{index}{t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.${key}`)}{' '}</UseStyled.TitlePayment>

    switch (paymentChannel.key) {
      case 'CASH':
        return (
          <div className="pt-3">
            {title}
            <PrivilegeList
              listOrderPayment={props.listOrderPayment}
              paidChannel={paidChannel}
              itemChannel={itemChannel}
              handleCheckBox={(type: string, id: any) => handleCheckBox(paymentChannelId, type, id)}
              handleValueChannel={(value: any) => handleValueChannel(paymentChannelId, value)}
              handleValuePaidItem={(value: any, type: string, id: any) => handleValuePaidItem(paymentChannelId, value, type, id)}
              systemConfig={{
                ...props.systemConfig,
                type: 'PaymentChannels'
              }}
              title={t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.LIST.CASH')}
              listOrder={props.listOrder}
              advance={props.advance}
              dataPatientCase={props.dataPatientCase}
            />
          </div>
        )
      case 'TRANSFER': return (
        <div className="pt-3">
          {title}
          <Typography className="mt-3" sx={{ fontWeight: 500 }}>
            {t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.LIST.TRANSFER`)}
          </Typography>
          <div className="pl-3">
            {_.map(bankTransfers, (bank, index) => {
              return (
                <UseStyled.ButtonBank
                  onClick={() => handleSelectPaymentChannelTransfer(paymentChannel, bank)}
                  className={`d-inline-block mt-3 mr-2 ${paymentChannel?.bank?.bankId === bank.bankId ? 'active' : ''}`}
                >
                  <img src={`${fileUrl}/${bank.bankAvata}`} style={{ width: 30, height: 30 }} onError={onImgError} alt="" />
                </UseStyled.ButtonBank>
              )
            })}
            {bank?.bankId && (
              <PrivilegeList
                listOrderPayment={props.listOrderPayment}
                paidChannel={paidChannel}
                itemChannel={itemChannel}
                handleCheckBox={(type: string, id: any) => handleCheckBox(paymentChannelId, type, id)}
                handleValueChannel={(value: any) => handleValueChannel(paymentChannelId, value)}
                handleValuePaidItem={(value: any, type: string, id: any) => handleValuePaidItem(paymentChannelId, value, type, id)}
                systemConfig={{
                  ...props.systemConfig,
                  type: 'PaymentChannels'
                }}
                title={
                  <Box className="d-flex align-items-start align-items-md-center mx-0" sx={{ marginLeft: '-16px' }}>
                    <img src={`${fileUrl}/${bank.bankAvata}`} className="mt-1 mt-md-0" style={{ borderRadius: '4px', width: 30, height: 30 }} onError={onImgError} alt="" />
                    <Box>
                      <Typography className="d-inline-block ml-2">{bank.bankName}</Typography>
                      <UseStyled.TypographyBankNumber className="d-md-inline-block ml-2 ml-md-5">{t('PAYMENT.FORM_PAYMENT.TITLE_BANK', { number: bank.bankAccountNumber })}</UseStyled.TypographyBankNumber>
                    </Box>
                  </Box>
                }
                listOrder={props.listOrder}
                advance={props.advance}
                dataPatientCase={props.dataPatientCase}
              />
            )}
          </div>
        </div>
      )
      case 'CREDIT': return (
        <div className="pt-3">
          {title}
          <Typography className="mt-3" sx={{ fontWeight: 500 }}>
            {t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.LIST.CREDIT`)}
          </Typography>
          <div className="pl-3">
            {_.map(bankCredits, (bank, index) => {
              return (
                <UseStyled.ButtonBank
                  onClick={() => handleSelectPaymentChannelCredit(paymentChannel, bank)}
                  className={`d-inline-block mt-3 mr-2 ${paymentChannel?.bank?.bankId === bank.bankId ? 'active' : ''}`}
                >
                  <img src={`${fileUrl}/${bank.bankAvata}`} style={{ width: 30, height: 30 }} onError={onImgError} alt="" />
                </UseStyled.ButtonBank>
              )
            })}
            {bank?.bankId && (
              <PrivilegeList
                listOrderPayment={props.listOrderPayment}
                paidChannel={paidChannel}
                itemChannel={itemChannel}
                handleCheckBox={(type: string, id: any) => handleCheckBox(paymentChannelId, type, id)}
                handleValueChannel={(value: any) => handleValueChannel(paymentChannelId, value)}
                handleValuePaidItem={(value: any, type: string, id: any) => handleValuePaidItem(paymentChannelId, value, type, id)}
                systemConfig={{
                  ...props.systemConfig,
                  type: 'PaymentChannels'
                }}
                title={
                  <div>
                    <Box className="d-flex align-items-start align-items-md-center mx-0 w-100" sx={{ marginLeft: '-16px' }}>
                      <img src={`${fileUrl}/${bank.bankAvata}`} className="mt-1 mt-md-0" style={{ borderRadius: '4px', width: 30, height: 30 }} onError={onImgError} alt="" />
                      <Box>
                        <Typography className="d-inline-block ml-2">{bank.bankName}</Typography>
                      </Box>
                    </Box>
                    <Box className="d-flex align-items-start align-items-md-center w-100">
                      <Box>
                        < UseStyled.TypographyBankNumber className="d-md-inline-block ml-2 ml-md-5 mr-2">{t('PAYMENT.FORM_PAYMENT.TITLE_CREDIT')}</UseStyled.TypographyBankNumber>
                        {_.map(bank.credit, (card, index) => (
                          <UseStyled.ButtonBank onClick={() => handleSelectPaymentChannelCard(paymentChannel, card)} className={`d-inline-block mr-2 ${bank.cardTypeId === card.cardTypeId ? 'active' : ''}`} style={{}}>
                            <img src={`${fileUrl}/${card.cardTypeLogo}`} style={{ width: 30, height: 30 }} onError={onImgError} alt="" />
                          </UseStyled.ButtonBank>
                        ))}
                      </Box>
                    </Box>
                  </div>
                }
                listOrder={props.listOrder}
                advance={props.advance}
                dataPatientCase={props.dataPatientCase}
              />
            )}
          </div>
        </div>
      )
      case 'DEBIT': return (
        <div className="pt-3">
          {title}
          <Typography className="mt-3" sx={{ fontWeight: 500 }}>
            {t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.LIST.DEBIT`)}
          </Typography>
          <div className="pl-3">
            {_.map(bankDebits, (bank, index) => {
              return (
                <UseStyled.ButtonBank
                  onClick={() => handleSelectPaymentChannelDebit(paymentChannel, bank)}
                  className={`d-inline-block mt-3 mr-2 ${paymentChannel?.bank?.bankId === bank.bankId ? 'active' : ''}`}
                >
                  <img src={`${fileUrl}/${bank.bankAvata}`} style={{ width: 30, height: 30 }} onError={onImgError} alt="" />
                </UseStyled.ButtonBank>
              )
            })}
            {bank?.bankId && (
              <PrivilegeList
                listOrderPayment={props.listOrderPayment}
                paidChannel={paidChannel}
                itemChannel={itemChannel}
                handleCheckBox={(type: string, id: any) => handleCheckBox(paymentChannelId, type, id)}
                handleValueChannel={(value: any) => handleValueChannel(paymentChannelId, value)}
                handleValuePaidItem={(value: any, type: string, id: any) => handleValuePaidItem(paymentChannelId, value, type, id)}
                systemConfig={{
                  ...props.systemConfig,
                  type: 'PaymentChannels'
                }}
                title={
                  <div>
                    <Box className="d-flex align-items-start align-items-md-center w-100" sx={{ marginLeft: '-16px' }}>
                      <img src={`${fileUrl}/${bank?.bankAvata}`} className="mt-1 mt-md-0" style={{ borderRadius: '4px', width: 30, height: 30 }} onError={onImgError} alt="" />
                      <Box>
                        <Typography className="d-inline-block ml-2">{bank?.bankName}</Typography>
                      </Box>
                    </Box>
                    <Box className="d-flex align-items-start align-items-md-center w-100">
                      <Box>
                        <UseStyled.TypographyBankNumber className="d-md-inline-block ml-2 ml-md-5 mr-2">{t('PAYMENT.FORM_PAYMENT.TITLE_CREDIT')}</UseStyled.TypographyBankNumber>
                        {_.map(bank?.debit, (card, index) => (
                          <UseStyled.ButtonBank onClick={() => handleSelectPaymentChannelCard(paymentChannel, card)} className={`d-inline-block mr-2 ${bank?.cardTypeId === card.cardTypeId ? 'active' : ''}`}>
                            <img src={`${fileUrl}/${card.cardTypeLogo}`} style={{ width: 30, height: 30 }} onError={onImgError} alt="" />
                          </UseStyled.ButtonBank>
                        ))}
                      </Box>
                    </Box>
                  </div>
                }
                listOrder={props.listOrder}
                advance={props.advance}
              />
            )}
          </div>
        </div>
      )
      case 'WALLET': return (
        <div className="pt-3">
          {title}
          <PrivilegeList
            listOrderPayment={props.listOrderPayment}
            paidChannel={paidChannel}
            itemChannel={itemChannel}
            handleCheckBox={(type: string, id: any) => handleCheckBox(paymentChannelId, type, id)}
            handleValueChannel={(value: any) => handleValueChannel(paymentChannelId, value)}
            handleValuePaidItem={(value: any, type: string, id: any) => handleValuePaidItem(paymentChannelId, value, type, id)}
            systemConfig={{
              ...props.systemConfig,
              type: 'PaymentChannels'
            }}
            title={t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.LIST.WALLET')}
            listOrder={props.listOrder}
            advance={props.advance}
            dataPatientCase={props.dataPatientCase}
          />
        </div>
      )
      case 'TREATMENTRIGHT': return (
        <div className="pt-3">
          {title}
          <TreatmentDiscount
            listOrderPayment={props.listOrderPayment}
            paidChannel={paidChannel}
            itemChannel={itemChannel}
            handleCheckBox={(type: string, id: any) => handleCheckBox(paymentChannelId, type, id)}
            handleSelectBenefit={(treatmentRight: any) => handleSelectBenefit(treatmentRight)}
            handleValueChannel={(value: any) => handleValueChannel(paymentChannelId, value)}
            handleChangValueTreatmentRight={(patientTreatmentRightId: number, value: any) => handleChangValueTreatmentRight(paymentChannelId, patientTreatmentRightId, value)}
            handleCheckBoxItemTreatmentRight={(patientTreatmentRightId: number, value: any, type: string, id: any) => handleCheckBoxItemTreatmentRight(paymentChannelId, patientTreatmentRightId, value, type, id)}
            handleValuePaidItem={(value: any, type: string, id: any, patientTreatmentRightId?: number) => {
              if (patientTreatmentRightId)
                handleValuePaidTreatmentRightItem(paymentChannelId, value, type, id, patientTreatmentRightId)
              else handleValuePaidItem(paymentChannelId, value, type, id)
            }}
            systemConfig={{
              ...props.systemConfig
            }}
            listOrder={props.listOrder}
            treatmentRights={props.treatmentRights || []}
            dataPatientCase={props.dataPatientCase}
          />
        </div>
      )
      case 'ADVANCE': return (
        <div className="pt-3">
          {title}
          <PrivilegeList
            listOrderPayment={props.listOrderPayment}
            paidChannel={paidChannel}
            itemChannel={itemChannel}
            handleCheckBox={(type: string, id: any) => handleCheckBox(paymentChannelId, type, id)}
            handleValueChannel={(value: any) => handleValueChannel(paymentChannelId, value)}
            handleValuePaidItem={(value: any, type: string, id: any) => handleValuePaidItem(paymentChannelId, value, type, id)}
            systemConfig={{
              ...props.systemConfig,
              type: 'PaymentChannels'
            }}
            title={t('PAYMENT.FORM_PAYMENT.TITLE_DISCOUNT', { privilege: 'เงินล่วงหน้า', price: numberToCurrencyFormat(props.advanceBalance) })}
            listOrder={props.listOrder}
            advance={props.advance}
            dataPatientCase={props.dataPatientCase}
          />
        </div>
      )
      default: return null
        break;
    }
  }, [visiblePaymentChannels, props.listOrderPayment])

  return (
    <Box className="mb-3">
      {!props.systemConfig.isUseNhso && <Privilege
        paymentChannels={props.selectdChannel}
        listOrderPayment={props.listOrderPayment}
        handleSelectPaymentChannel={handleSelectPaymentChannel}

        isAdvancePayment={props.advance || false}
        promotionList={props.promotionList}
        voucherList={props.voucherList}
        handleCheckBox={(paymentChannelId: number, type: string, id: any) => handleCheckBox(paymentChannelId, type, id)}
        handleSelectBenefit={(treatmentRight: any) => handleSelectBenefit(treatmentRight)}
        handleValueChannel={(paymentChannelId: number, value: any) => handleValueChannel(paymentChannelId, value)}
        handleChangValueTreatmentRight={(paymentChannelId: number, patientTreatmentRightId: number, value: any) => handleChangValueTreatmentRight(paymentChannelId, patientTreatmentRightId, value)}
        handleCheckBoxItemTreatmentRight={(paymentChannelId: number, patientTreatmentRightId: number, value: any, type: string, id: any) => handleCheckBoxItemTreatmentRight(paymentChannelId, patientTreatmentRightId, value, type, id)}
        handleValuePaidItem={(paymentChannelId: number, value: any, type: string, id: any, patientTreatmentRightId: number) => {
          handleValuePaidTreatmentRightItem(paymentChannelId, value, type, id, patientTreatmentRightId)

        }}
        listOrder={props.listOrder}
        systemConfig={props.systemConfig}
        patientId={props.patientId}
        overdue={props.objPayment.overdue}
        date={props.date}
        handleRemoveVoucher={handleRemoveVoucher}
        handleRemovePromotion={handleRemovePromotion}
      />}

      {/* {props.advance ?
          <Grid container spacing={2} className="mt-0">
            <Grid sm={5}>
              <UseStyled.Title className="px-md-2 px-xl-3 mt-2">
                {t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.TITLE')}
              </UseStyled.Title>
            </Grid>
            <Grid className='mr-2'>
              <Typography className="pl-3 d-none d-sm-block mt-2" sx={{ flex: 'none' }}>
                {t('PAYMENT.FORM_PAYMENT.RECEIPT_TYPE')}
              </Typography>
            </Grid>
            <Grid sm={2} >
              <BasicSelect
                selectId=""
                label=""
                labelId="billPrefixId"
                onchange={(e: any) => {
                  handleSetBillPrefix(e.target.value)
                }}
                value={objPayment.prefix || ''}
                options={_.map(billPrefixes, (i: any) => (
                  <MenuItem key={i.billPrefixId || i.paymentChannelId} value={i.prefix || i.defaultPrefix}>
                    {i.prefix || i.defaultPrefix}
                  </MenuItem>
                ))}
              />
            </Grid>
            <Grid>
              <Typography className="pl-3 d-none d-sm-block mt-2" sx={{ flex: 'none' }}>
                {'-xxx-xx-xx-xxxxx'}
              </Typography>
            </Grid>
          </Grid>
          :
    <></>
        } */}

      <UseStyled.Title className="px-md-2 px-xl-3">
        {t('PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.TITLE')} <span className="text-muted fz-14 pl-2">{t('PAYMENT.FORM_PAYMENT.LEFTOVER_PAY')} : {numberToCurrencyFormat(props.objPayment.overdue || 0)} {t('CURRENCY_CHANGE.TH')}</span>{' '}
      </UseStyled.Title>

      <Box className="px-md-2 px-xl-3" padding={'16px 0'}>
        <Grid container spacing={1} className="mt-0" sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px 0' }}>
          {Object.keys(visiblePaymentChannels).map((key: string, index: number) => {
            const paymentChannel = visiblePaymentChannels[key]
            const { isActive, channelIndex, isDisabled } = paymentChannel

            return (
              <Grid
                key={`payment-channel-${key}-${index}`}
                item
                xs={props.advance ? 3 : 2}
                className=""
                sx={{
                  minWidth: 'calc(100% / 3)',
                  maxWidth: 'calc(100% / 3)',
                  minHeight: '50px',
                  maxHeight: '50px',
                  paddingTop: '0px !important',
                }}
              >
                <UseStyled.ChannelBox
                  onClick={() => {
                    if (!isDisabled) {
                      handleSelectPaymentChannel(paymentChannel)
                    }
                  }}
                  className={`align-items-center px-2 px-sm-0 text-ellipsis ${isActive ? 'active' : ''} ${isDisabled ? 'disabled' : ''} ${props.systemConfig.isUseNhso ? paymentChannel.paymentChanel !== 5 ? 'disabled' : '' : ''}`}
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex start !important',
                    paddingLeft: '24px !important',
                    gap: '8px',
                    width: '100%',
                    height: '100%',
                    borderWidth: '2.5px !important',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    '.number': {
                      paddingLeft: ' 4px !important',
                      textAlign: 'left'
                    },
                    'svg': {
                      height: '29px !important'
                    },
                    '.MuiTypography-root': {
                      width: 'fit-content !important'
                    }
                  }}
                >
                  {channelIndex && channelIndex !== 0 && <p className={'number'}>{channelIndex}</p>}

                  {/* Render appropriate icon based on channel key */}
                  {paymentChannel.key === 'TREATMENTRIGHT' && <TreatmentRight active={isActive ? colors.themeSecondColor : ''} />}
                  {paymentChannel.key === 'ADVANCE' && <Advance active={isActive ? colors.themeSecondColor : ''} />}
                  {paymentChannel.key === 'CASH' && <Cash active={isActive ? colors.themeSecondColor : ''} />}
                  {paymentChannel.key === 'TRANSFER' && <Bank active={isActive ? colors.themeSecondColor : ''} />}
                  {paymentChannel.key === 'CREDIT' && <Credit active={isActive ? colors.themeSecondColor : ''} />}
                  {paymentChannel.key === 'DEBIT' && <Debit active={isActive ? colors.themeSecondColor : ''} />}
                  {paymentChannel.key === 'WALLET' && <Wallet active={isActive ? colors.themeSecondColor : ''} />}

                  <Tooltip
                    title={t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.${paymentChannel.key}`)}
                    arrow
                    placement="right"
                  >
                    <Typography
                      className="pl-2 pl-sm-0 pt-sm-1 text-ellipsis channel-name"
                      sx={{
                        color: isDisabled
                          ? colors.disabledGray
                          : isActive
                            ? colors.themeSecondColor
                            : colors.disabledGray
                      }}
                    >
                      {t(`PAYMENT.FORM_PAYMENT.PAYMENT_METHODS.OPTION.${paymentChannel.key}`)}
                    </Typography>
                  </Tooltip>
                </UseStyled.ChannelBox>
              </Grid>
            )
          })}
        </Grid>

        {_.map(Object.values(props.selectdChannel)
          .sort((a: any, b: any) => (a.channelIndex ?? 9999) - (b.channelIndex ?? 9999)), (paymentChannel: any, index: number) => {
            if (!paymentChannel.isActive) return null
            return renderChannel(paymentChannel)
          })}
      </Box>
    </Box>
  )
}

export default memo(PaymentChannels)
